<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import PharmacyRelationSettingEditComponent from "../../Common/PharmacyRelationSettingEditComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const listRef = ref();
const searchWord = ref('');
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const fields = ref([
  {field_name: '', field_key: 'favorite', width: '5%', align: 'text-center'},
  {field_name: 'グループ名', field_key: 'medicine_group_name', width: '80%', align: 'text-left', sorted:true},
  {field_name: '取引先', field_key: 'relation_pharmacy.pharmacy_name', width: '80%', align: 'text-left', sorted:true},
  {field_name: '', field_key: 'action_edit', width: '5%', align: 'text-center'},
]);

const isLoadingDialog = ref(false);
const optionFields = ref({
  'search_word' : searchWord.value,
  'page_size' : 30,
});
const listSearch = () => {
  optionFields.value.search_word = searchWord.value;
  listRef.value.resetItem();
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const pharmacyRelationSetting = reactive({});
const isEditPharmacyRelationDialog = ref(false);
const showEditPharmacyRelation = (item) => {
  for (let key in item) {
    pharmacyRelationSetting[key] = item[key];
  }
  isEditPharmacyRelationDialog.value = true;
}
const closeEditPharmacyRelation = () => {
  isEditPharmacyRelationDialog.value = false;
}
const updateComplete = (data) => {
  let item = listRef.value.getItemById(data.id);
  item = data;
  listRef.value.updateItem(item);
  closeEditPharmacyRelation();
}
const toggleFavorite = async (item) => {
  try {
    let params = new FormData();
    params.append('id',item.id);
    const response = await axios(props.apis.pharmacy_relation_setting_favorite_update,{method:"post",data:params});
    if (response.data.status == 200) {
      listRef.value.updateItem(response.data.data);
    } else {
      errorAlert(response.data.message);
    }
  } catch (e) {
  }
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="pharmacy_relation_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
      <div class="absolute top-2 left-2">
        <help-action
          help-key="order_help"
        ></help-action>
      </div>
      <div class="mb-2 mt-1">
        <search-box
          :search-word="searchWord"
          :on-change="onSearchWordChange"
          :on-enter="onSearchWordEnter"
          place-holder="取引先名を入力"
      ></search-box>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :option-fields="optionFields"
        :api-url="apis.pharmacy_relation_setting_list"
        height="72vh"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" class="text-center">
          <div v-if="field.field_key == 'action_edit'">
            <a href="javascript:void(0)" @click="showEditPharmacyRelation(slotProps.item)"><i class="fa-regular fa-pen-to-square"></i></a>
          </div>
          <div v-else-if="field.field_key == 'favorite'">
            <a href="javascript:void(0)" @click="toggleFavorite(slotProps.item)">
              <i :class="(slotProps.item.favorite_level == 1 ? 'fa-solid text-amber-400' : 'fa-regular text-gray-300') + ' fa-star'"></i>
            </a>
          </div>
          <div v-else :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditPharmacyRelationDialog"
  width="60%"
  :close="closeEditPharmacyRelation"
>
  <template v-slot:header>
    取引先編集
  </template>
  <template v-slot:default>
    <pharmacy-relation-setting-edit-component
      :apis="apis"
      :pharmacy-relation-setting="pharmacyRelationSetting"
      :cancel="closeEditPharmacyRelation"
      :update-complete="updateComplete"
    ></pharmacy-relation-setting-edit-component>
  </template>
</modal-dialog>

</template>

